import { LocalStorageService } from './../../../services/local-storage.service';
import { map } from 'rxjs';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { MatDialog } from '@angular/material/dialog';
import { ExportComponent } from '../../dashboard/distributor/export/export.component';
import { SpinnerService } from 'src/app/services/shared/spinner.service';



@Component({
  selector: 'app-mwe-table',
  templateUrl: './mwe-table.component.html',
  styleUrls: ['./mwe-table.component.css']
})
export class MweTableComponent implements OnChanges, AfterViewInit {

  @Input() actions: Array<any> = [];

  @Input()
  showSearch: boolean | undefined;
  @Input()
  showMasterDataSearch: boolean | undefined;

  @Input()
  showFilterByDate: boolean | undefined;

  @Input()
  showAddButton: boolean | undefined;

  @Input() showHeader: boolean = true;

  @Input()
  showFilter: boolean | undefined;

  @Input()
  showExport: boolean | undefined;

  @Input()
  showImport: boolean | undefined;

  @Input()
  showSelected: boolean | undefined;

  @Input()
  columns!: Array<any>;

  @Input()
  data: Array<any> = [];

  @Input() fieldsToInclude: string[] = [];
  @Input() exportTitle: string = '';

  @Input()
  actionType: string | undefined;

  @Input() showPagination: boolean = true;

  @Input() showAddButtonName = 'Add';

  @Input() isRowsCursor: boolean = false;

  @Input() totalEntries: number = -1;

  @Input() hidePagination!: boolean;

  @Input()
  title!: string;
  @Output() selectedAction = new EventEmitter<any>();

  @Input() showDropdownFilter!: boolean;

  @Input() filterDropdown: any;
  @Input() currentPageChanged: number = 0;
  @Output() pageChanged = new EventEmitter<{ pageIndex: number, pageSize: number }>();
  @Output() statusChange = new EventEmitter<{ id: string, leadState: string }>();

  @Input() dynamicPageSize ?: number;

  @Output() applyyFilter = new EventEmitter<string>();
  @Input() isDynemicPagination: boolean = false;
  @Input() preSelectedList: any[] = [];
  @Input() createdByExport!:any;
  @Input() masterDataSearch: string = '';

  @Output() rowIdx = new EventEmitter<any>();

  @Output() resendVerificationEmail = new EventEmitter<any>();

  @Output() searchTerm = new EventEmitter<string>();

  dataSource = new MatTableDataSource<any[]>;
  paginator!: MatPaginator;
  sort!: MatSort;
  pageChange: any;
  dialog: any;
  userId: any;
  exhibitionId: any;
  searchValue: string = '';
  @Input() initialSearchValue: string = '';
  @Input() isEndCustomerViewMoreData: any = null;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    if (Array.isArray(this.dataSource.data)) {
      this.dataSource.paginator = this.paginator;
    }
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    if (this.dataSource.data) {
      if (this.dataSource.data && Array.isArray(this.dataSource.data)) {
        this.dataSource.data = this.dataSource.data.slice();
      }
      if (this.dataSource.data && Array.isArray(this.dataSource.data)) {
        this.dataSource.sort = this.sort;
      }
    }
  }
  displayedColumns: any[] = [];

  addAction = MweConstants.addAction;
  scheduleCallAction = MweConstants.scheduleCall;
  sendMailAction = MweConstants.sendMail;
  sendRequestAction = MweConstants.sendRequest;
  searchAction = MweConstants.searchAction;
  filterAction = MweConstants.filterAction;
  importAction = MweConstants.importAction;
  exportAction = MweConstants.exportAction;
  fileDownloadAction = MweConstants.fileDownloadAction;
  fillterDropdownAction = MweConstants.fillterDropdownAction;
  filterByDateAction = MweConstants.filterByDateAction;
  checkBox = MweConstants.checkBox;
 showNoRecordsFound:boolean = false;
  roleName!: string;
  createdBy!: string;
  isSuperAdmin: boolean = false;


  constructor(private changeRef: ChangeDetectorRef, private _liveAnnouncer: LiveAnnouncer,
    private sweetAlertService: SweetAlertService,
    private dialogExport: MatDialog,
    private localStorageService: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private spinnerService: SpinnerService

  ) {
    this.userId = this.localStorageService.getItem('userId');
      this.roleName = this.localStorageService.getItem('roleName');
    
      if (this.roleName === 'OEM') {
        this.createdBy = this.localStorageService.getItem('oemId');
      } else if (this.roleName === 'DISTRIBUTOR') {
        this.createdBy = this.localStorageService.getItem('distributorId');
      } else if (this.roleName === 'SUPER_ADMIN') {
        this.createdBy = this.localStorageService.getItem('userId');
      }
      else {
        this.createdBy = this.localStorageService.getItem('userId');
      }
   }

  ngOnChanges(changes: SimpleChanges): void {
    this.currentPage = this.currentPageChanged;
    this.showNoRecordsFound = false;
    this.displayedColumns = this.columns.filter(column => column.visible).map(column => column.property);
    
    if (changes['masterDataSearch'] && changes['masterDataSearch'].currentValue !== changes['masterDataSearch'].previousValue) {
      this.searchValue = this.masterDataSearch;
    }
    if(this.data === undefined) {
      this.dataSource = new MatTableDataSource<any[]>([]);
      this.showNoRecordsFound = false;
      this.showPagination = true;
      return;
    }
    if((this.data && this.data.length !== 0) || this.totalEntries > 0) {
      this.showNoRecordsFound = false;
      this.dataSource = new MatTableDataSource<any[]>(this.data);
      this.showPagination = true; 
    } else if(!this.data || this.data.length === 0) {
      this.data = [];
      this.dataSource = new MatTableDataSource<any[]>(this.data);
      this.showPagination = false;
      if(this.totalEntries === 0) {
        this.totalEntries = -1;
      }
      this.showNoRecordsFound = true;
    }
    this.updateTableData();
    this.ngAfterViewInit();
  }
  ngOnInit() {
    this.spinnerService.showSpinner();
    this.showNoRecordsFound = false;
    this.spinnerService.hideSpinner();
    this.searchValue = this.masterDataSearch||this.initialSearchValue;
    }
    
    clearSearch() {
      this.searchValue = '';
      const event = { target: { value: '' } } as any;
      this.applyFilter(event);
    }

  ngAfterViewInit() {
    if (Array.isArray(this.dataSource.data)) {
      this.dataSource.data = this.dataSource.data.slice();
      this.dataSource.paginator = this.paginator;
    }
    if (this.dataSource.data) {
      if (Array.isArray(this.dataSource.data)) {
        this.dataSource.data = this.dataSource.data.slice();
      }
      if (this.dataSource.data) {
        if (Array.isArray(this.dataSource.data)) {
          this.dataSource.data = this.dataSource.data.slice();
          this.dataSource.sort = this.sort;
        }
      }

    }
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      let matchFound = false;
      for (let column of this.displayedColumns) {
        if (column in data) {
          if (data[column]) {
            matchFound = (matchFound || data[column].toString().trim().toLowerCase().includes(filter.trim().toLowerCase()))
          }
        }
      }
      return matchFound;
    }
    this.changeRef.detectChanges();
  }

  convertToCSV(data: any[]): string {
    if (!data || !data.length) {
      return '';
    }
    const header = Object.keys(data[0]).join(',');
    const rows = data.map(item => Object.values(item).join(','));
    return `${header}\n${rows.join('\n')}`;
  }
  
  exportData() {
    
    const dialogRef = this.dialogExport.open(ExportComponent, {
      height:'auto',
      width : 'auto',
      data: {
        title: this.exportTitle,
        exhibitionId: this.exportTitle === 'Exhibitions' || 'Webinars' || 'Jobs' ? this.createdBy : ''
      }
    });
    dialogRef.afterClosed().subscribe((result: any)=>{
      if(result === 'Success'){
        this.sweetAlertService.showSuccess(result,"File downloaded Sucessfully!!");
      }
    });

  }
 
  announceSortChange(sortState: any) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  updateAction(obj: any, type: string) {
    this.selectedAction.emit({ row: obj, action: type });
  }
  deleteAction(row: any) {
    this.selectedAction.emit({ row, action: 'delete' });
  }

  onStatusChange(row: any, column: any) {
    this.statusChange.emit({ id: row.id, leadState: row[column.property] });
  }

  rowClicked(row: any) {
    this.rowIdx.emit(row.id);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchTerm.emit(filterValue);
  
    if (this.showMasterDataSearch || this.showSearch) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
  
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
  
      // if(this.dataSource.filteredData === null) {
      //   this.dataSource.filteredData = [];
      // }

      // this.showNoRecordsFound = (this.dataSource.filteredData && this.dataSource.filteredData.length !== 0 && this.data && this.data.length !== 0)? false : true;
      if(filterValue === '') {
        this.showNoRecordsFound = false;
      }
      // this.showPagination = (this.dataSource.filteredData && this.dataSource.filteredData.length !== 0 && this.data && this.data.length !== 0)? true : false;
    } else {
      this.currentPage = 0;
      if (this.paginator) {
        this.paginator.pageIndex = this.currentPage;
        this.dataSource.paginator = this.paginator;
      }
      this.dataSource.filter = filterValue.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
      
      this.showNoRecordsFound = this.dataSource.filteredData.length === 0;
      this.showPagination = this.dataSource.filteredData.length > 0;
    }
  }

  updateTableData() {
    if(this.data && this.data.length !== 0) {
      this.totalData = this.data?.length;

    if(this.dynamicPageSize !== null && this.dynamicPageSize !== undefined) {
      this.pageSize = this.dynamicPageSize
    }

    if (this.paginator) {
      this.paginator.pageIndex = this.currentPage;
      this.dataSource.paginator = this.paginator;
    }
    }
  }
  pageSize = 10;
  currentPage = 0;
  totalData = this.data?.length;
  changePage(pageIndex: number) {
    this.currentPage = pageIndex;
    this.pageChanged.emit({ pageIndex: this.currentPage, pageSize: this.pageSize });
    this.updateTableData();
  }

  changePageSize(pageSize: number) {
    this.pageSize = pageSize;
    this.currentPage = 0;
    this.pageChanged.emit({ pageIndex: this.currentPage, pageSize: this.pageSize });
    this.updateTableData();
  }

  getTotalPages(): number {
    return Math.ceil(this.totalEntries / this.pageSize);
  }

  getPageNumbers(): (number | string)[] {
    const totalPages = this.getTotalPages();
    const currentPage = this.currentPage;
    const pageNumbers: (number | string)[] = [];
    // Always show the first page
    pageNumbers.push(0);

    // Show ellipsis if there are more than 3 pages before the current page
    if (currentPage > 2) {
      pageNumbers.push('...');
    }

    // Show current page and its neighbors
    for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages - 2, currentPage + 1); i++) {
      pageNumbers.push(i);
    }

    // Show ellipsis if there are more than 3 pages after the current page
    if (currentPage < totalPages - 3) {
      pageNumbers.push('...');
    }

    // Always show the last page if total pages is greater than 1
    if (totalPages > 1) {
      pageNumbers.push(totalPages - 1);
    }

    return pageNumbers;
  }
  openUrl(url: any) {
    window.open(url, '_blank')
  }

  getFileName(url: string): any {
    const parts = url.split('/');
    return parts[parts.length - 1];

  }

  getCatalogFileName(url: any) {
    if(!url) return '';
    const extractedFromUrl = url.split('/')?.pop();
    if(extractedFromUrl === '' || extractedFromUrl === null || extractedFromUrl === undefined) {
      return '';
    } else if(extractedFromUrl) {
      return extractedFromUrl?.split('.')?.slice(0, -1)!.join('.')!.replace(/^[^_]+_/, '');
    }
  }

  calculateSerialNumber(index: number): number {
        return (this.currentPage * this.pageSize) + index + 1;
  }
  isSelected(id: string, preSelectedList: string[] | null): boolean {
    if (!preSelectedList) return false;
    const sanitizedId = id.replace(/['"]+/g, '').trim();
    for (const item of preSelectedList) {
      const sanitizedItem = item === undefined || item === null ? '' : item.replace(/['"]+/g, '').trim(); 
      if (sanitizedItem === sanitizedId) {
        return true; 
      }
    }
    return false;
  }
  
  resendMail(row: any) {
    if(row.resendMail === "assets/images/verified-email-icon.svg") {
      return;
    }
    
    this.resendVerificationEmail.emit(row);
  }
  getFieldsArray(fields: any) {
    if(fields === null || fields === undefined) {
      return []; 
    } else if(fields) {
      return fields.map((field: any) => {
        return field.label;
      })
    }
  }
  
}
